var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1840_1304)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.175 11.16C15.7798 9.80981 13.9105 9.06112 11.9691 9.07494C10.0277 9.08875 8.1692 9.86397 6.79342 11.2338C5.41764 12.6037 4.63445 14.4588 4.6123 16.4002C4.59015 18.3416 5.3308 20.2141 6.67496 21.615L18 32.85L29.325 21.6C30.152 20.7659 30.7685 19.7468 31.1233 18.627C31.4781 17.5073 31.5611 16.3192 31.3654 15.161C31.1697 14.0028 30.7009 12.9079 29.9978 11.9669C29.2947 11.0259 28.3777 10.266 27.3225 9.74998C26.314 9.24809 25.2014 8.99113 24.075 8.99998C23.0984 8.99913 22.1315 9.19229 21.2302 9.56824C20.329 9.94419 19.5114 10.4954 18.825 11.19L18 12L17.175 11.16Z",
    fill: "#DF704D",
    stroke: "#77280C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1840_1304"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeart);
export default __webpack_public_path__ + "static/media/heart.6652dd98955f6556750adf408d31279c.svg";
export { ForwardRef as ReactComponent };